<div id="hli_UseImageList" #hli_UseImageList class="frame-solid wj-tabpane"
  forcedEnabledMode="true">
  <ul #useImageGroups>
    <li *ngFor="let item of useImageList; let i = index;"
      [style.padding.px]="2"
      (mousedown)="eventUseImageList_ITEMCLICK.emit({event: $event, index: i, useImageList: useImageList, useImageGroups: useImageGroups})">
      <app-image-info-renderer5002 [data]="item"></app-image-info-renderer5002>
    </li>
  </ul>
</div>
